import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { IPublicTicket, IServiceInfo } from '../../../models'
import { IStoreState } from '../../../store/states'
import MapSlot from '../../MapSlot'
import { setDisplayedActiveTicketsAction, setIsAlterationsModalOpenAction } from '../../../store/actions'
import { images } from '../../../images'
import { SuggestionService } from '../../../services'
import StyledDiv from './styles'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  serviceInfos: IServiceInfo[]
}

interface IState {
  activeTickets: IPublicTicket[]
}

class MapStopsView extends PureComponent<IProps, IState> {
  private requestedServiceInfoIds = ''

  constructor(props: IProps) {
    super(props)

    this.state = {
      activeTickets: []
    }
  }

  public componentDidMount(): void {
    this.fetchActiveTickets()
  }

  public componentDidUpdate(previousProps: IProps): void {
    if (previousProps.serviceInfos !== this.props.serviceInfos) this.fetchActiveTickets()
  }

  public render(): ReactNode {
    const { serviceInfos } = this.props
    const { activeTickets } = this.state

    if (!serviceInfos || !serviceInfos.length) return null

    const hasAlterations = serviceInfos.some((serviceInfo) => serviceInfo.alterationMessages.length > 0)

    return (
      <StyledDiv>
        <MapSlot />
        <div className='map-warnings'>
          {
            hasAlterations &&
            <div className='alterations-icon' onClick={ this.handleAlterationsClick }>
              <img src={images.alteration} alt='alterations-icon' />
            </div>
          }
          {
            activeTickets.length > 0 &&
            <div className='alterations-icon' onClick={ this.handleActiveTicketsClick }>
              <img src={images.activeTicket} alt='active-tickets-icon' />
            </div>
          }
        </div>
      </StyledDiv>
    )
  }

  private fetchActiveTickets = async () => {
    const serviceInfos = this.props.serviceInfos ?? []
    const selectedServiceInfos = serviceInfos.filter((serviceInfo) => serviceInfo.selected)
    const shownServiceInfos = selectedServiceInfos.length ? selectedServiceInfos : serviceInfos
    const serviceInfoIds = shownServiceInfos
      .map((serviceInfo) => serviceInfo.id)
      .sort((first, second) => first - second)
    const requestedServiceInfoIds = serviceInfoIds.join(',')
    if (requestedServiceInfoIds === this.requestedServiceInfoIds) return

    this.requestedServiceInfoIds = requestedServiceInfoIds
    const activeTickets = await SuggestionService.getMapActiveTickets(serviceInfoIds)
    if (requestedServiceInfoIds === this.requestedServiceInfoIds) this.setState({ activeTickets })
  }

  private handleAlterationsClick = () => {
    this.props.dispatch(setIsAlterationsModalOpenAction(true))
  }

  private handleActiveTicketsClick = () => {
    this.props.dispatch(setDisplayedActiveTicketsAction(this.state.activeTickets))
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  serviceInfos: newReservation.serviceInfos
})

export default withRouter(connectRedux(mapStateToProps, MapStopsView as any))
